import {
    BrowserStorageItem,
    StorageType,
} from '@jsmdg/browser-storage/dist/services/browser-storage-item';
import { TTLStorageItem } from '@jsmdg/browser-storage/dist/services/ttl-storage-item';

export class TTLCacheWrapper<T> {
    private readonly ttlStorage: TTLStorageItem<Record<string, T>>;

    private readonly ttlMs: number;

    public constructor(storageKey: string, ttlSeconds: number) {
        this.ttlMs = ttlSeconds * 1_000;
        this.ttlStorage = new TTLStorageItem<Record<string, T>>(
            new BrowserStorageItem(storageKey, StorageType.SESSION_STORAGE),
            this.ttlMs,
        );
    }

    private getStore(): Record<string, T> {
        return this.ttlStorage.get() ?? {};
    }

    public get(key: string): T | null {
        const normalizedKey = key.trim();
        const store = this.getStore();
        const value = store[normalizedKey];
        return value ?? null;
    }

    public set(key: string, value: T): void {
        const normalizedKey = key.trim();
        this.ttlStorage.set({ ...this.getStore(), [normalizedKey]: value }, this.ttlMs);
    }

    public async getOrFetch(key: string, fetcher: () => Promise<T>): Promise<T> {
        const cached = this.get(key);
        if (cached !== null) {
            return cached;
        }

        const result = await fetcher();
        this.set(key, result);
        return result;
    }

    public has(key: string): boolean {
        return this.get(key) !== null;
    }

    public clear(): void {
        this.ttlStorage.remove();
    }
}
